<template>
  <v-container
    ref="container"
    v-resize="resize"
    class="widgetText--text widget pa-0"
    style="position: relative; height: 100%; overflow: hidden">
    <base-widget-header
      ref="widgetHeader"
      :label="labels.title"
      @close-parent-widget="close">
      <v-menu offset-y left transition="slide-y-transition">
        <template #activator="{on, attrs}">
          <v-btn
            x-small v-bind="attrs" icon
            v-on="on">
            <v-icon small color="widgetText">
              mdi-dots-horizontal
            </v-icon>
          </v-btn>
        </template>
        <v-list class="pa-0" width="150">
          <v-list-item dense @click="expandAll">
            <v-icon
              small color="widgetText" style="opacity: 0.8">
              mdi-unfold-more-horizontal
            </v-icon>
            <v-list-item-content
              class="pl-2 widgetText--text"
              :style="{fontSize: '14px', opacity: 0.8}">
              {{ labels.expand }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense @click="collapseAll">
            <v-icon
              small color="widgetText" style="opacity: 0.8">
              mdi-unfold-less-horizontal
            </v-icon>
            <v-list-item-content
              class="pl-2 widgetText--text"
              :style="{fontSize: '14px', opacity: 0.8}">
              {{ labels.collapse }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="viewsConfiguration && !isViewsWidgetForbidden" dense @click="addView">
            <v-icon
              small color="widgetText" style="opacity: 0.8">
              mdi-eye-plus-outline
            </v-icon>
            <v-list-item-content
              class="pl-2 widgetText--text"
              :style="{fontSize: '14px', opacity: 0.8}">
              {{ labels.addView }}
            </v-list-item-content>
          </v-list-item>
          <!-- Hidden doesn't work -->
          <!-- <v-list-item dense @click="addService">
            <v-icon
              small color="widgetText" style="opacity: 0.8">
              mdi-plus
            </v-icon>
            <v-list-item-content
              class="pl-2 widgetText--text"
              :style="{fontSize: '14px', opacity: 0.8}">
              {{ labels.addService }}
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </base-widget-header>
    <div
      ref="agTocTabs" :style="{
        position: 'absolute',
        top: headerHeight,
        width: '100%',
      }">
      <v-tabs v-model="selectedTab" hide-slider>
        <v-tab
          key="layersToc"
          href="#layersToc"
          :style="{
            width: '50%',
            color: selectedTab === 'layersToc' ?
              $vuetify.theme.themes.dark.elements :
              $vuetify.theme.themes.dark.widgetText,
            opacity: selectedTab === 'layersToc' ? '1' : '0.4',
            backgroundColor: selectedTab === 'layersToc' ? 'white' : '#e5e5e5',
          }">
          {{ labels.layers }}
        </v-tab>
        <v-tab
          key="legendToc"
          href="#legendToc"
          :style="{
            width: '50%',
            color: selectedTab === 'legendToc' ?
              $vuetify.theme.themes.dark.elements :
              $vuetify.theme.themes.dark.widgetText,
            opacity: selectedTab === 'legendToc' ? '1' : '0.4',
            backgroundColor: selectedTab === 'legendToc' ? 'white' : '#e5e5e5',
          }"
          :disabled="Object.keys(items).length === 0">
          {{ labels.legend }}
        </v-tab>
      </v-tabs>
      <v-row>
        <v-col cols="12" class="py-0">
          <v-divider />
        </v-col>
      </v-row>
    </div>
    <div
      :style="{
        position: 'absolute',
        top: fullHeaderHeight,
        height: computedHeight,
        width: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
      }">
      <v-tabs-items
        v-model="selectedTab"
        class="mt-3 px-5 widget"
        color="widgetText">
        <v-tab-item
          key="layersToc"
          value="layersToc">
          <div
            v-if="Object.keys(items).length === 0"
            :style="{opacity: '0.6', fontSize: '14px'}"
            class="pl-4 widgetText--text">
            {{ labels.noLayers }}
          </div>
          <v-card color="widget" flat>
            <v-card-text
              v-for="(value, id) in items"
              :key="id"
              class="pa-0">
              <v-treeview
                ref="tree"
                v-model="selection[id]"
                :open-all="isOpen(id)"
                :items="items[id]"
                selected-color="elements" selection-type="independent"
                dense selectable return-object
                @input="changeLayers(selection[id], id)">
                <template #label="{item}">
                  <BaseTooltip
                    v-if="ellipsis"
                    top nudge-top="-33" nudge-right="10">
                    <template #activator="{on, attrs}">
                      <span
                        :class="{'disabledItem': item.disabledItem} " v-bind="attrs"
                        v-on="on">
                        {{ item.name }}
                      </span>
                    </template>
                    <span>
                      {{ item.name }}
                    </span>
                  </BaseTooltip>
                  <div
                    v-else :class="{'disabledItem': item.disabledItem}"
                    style="white-space: pre-wrap">
                    {{ item.name }}
                  </div>
                </template>

                <template #append="{item}">
                  <v-menu v-if="!isSmallScreen && item.type !== 'group' && !rasterLayer(item)" offset-y left>
                    <template #activator="{on, attrs}">
                      <v-icon
                        v-if="item.url && item.children.length < 1 && item.type !== 'wms' "
                        v-show="(layerFilters[item.storeKey] || layerFilters[item.storeKey + '##' + item.id])"
                        :color="( (layerFilters[item.storeKey] || layerFilters[item.storeKey + '##' + item.id])
                          && (layerFilters[item.storeKey] || layerFilters[item.storeKey + '##' + item.id]).isFilterActive) ? 'elements' : 'gray'"
                        x-small>
                        mdi-filter
                      </v-icon>
                      <v-icon
                        v-if="item.url && item.children.length < 1 && item.type !== 'wms' "
                        v-show="(layerLabeling[item.storeKey] || layerLabeling[item.storeKey + '##' + item.id])"
                        :color="( (layerLabeling[item.storeKey] || layerLabeling[item.storeKey + '##' + item.id])
                          && isAnyLayerLabelActive(layerLabeling[item.storeKey] || layerLabeling[item.storeKey + '##' + item.id])) ? 'elements' : 'gray'"
                        small>
                        mdi-format-text-variant
                      </v-icon>
                      <v-icon
                        v-if="item.url && item.children.length < 1 && item.type !== 'wms' "
                        v-show="(layerSymbology[item.storeKey] || layerSymbology[item.storeKey + '##' + item.id])"
                        :color=" (layerSymbology[item.storeKey] || layerSymbology[item.storeKey + '##' + item.id])
                          && isAnyLayerSymbologyActive(layerSymbology[item.storeKey] || layerSymbology[item.storeKey + '##' + item.id]) ? 'elements' : 'gray'"
                        small>
                        mdi-symbol
                      </v-icon>
                      <v-icon
                        v-if="(item.index || item.children < 1) && item.id !== '183b1d72489-layer-3'"
                        v-bind="attrs" v-on="on">
                        mdi-dots-vertical
                      </v-icon>
                    </template>
                    <v-list dense class="pa-0">
                      <v-list-item v-if="item.index" class="pa-0">
                        <v-list-item-content class="pl-0 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                          <div class="mb-3 px-2">
                            {{ labels.transparency }}
                          </div>
                          <template class="pa-0">
                            <v-card-text class="pa-0">
                              <v-slider
                                ref="slider"
                                class="pa-4 ml-2 mr-4"
                                hide-details="true"
                                :value="item.transparency"
                                max="1"
                                min="0"
                                color="elements"
                                track-color="elements"
                                step="0.1"
                                :thumb-size="22"
                                thumb-label="always"
                                @input="changeTransparency($event, item)" />
                              <v-row v-if="item.children.length < 1">
                                <v-col cols="12" class="py-0">
                                  <v-divider />
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="item.children.length < 1 && item.type !== 'wms' && item.type !== 'building' && item.type !== 'scene' && item.type !== 'image' && !rasterLayer(item) && item.type" class="py-0 px-2" @click="openAttributeTable(item)">
                        <v-icon small color="widgetText" style="opacity: 0.6">
                          mdi-database-search-outline
                        </v-icon>
                        <v-list-item-content class="pl-2 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                          {{ labels.attributeTable }}
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="item.children.length < 1 && item.type !== 'wms' && item.type !== 'building' && item.type !== 'scene' && item.type !== 'image' && !rasterLayer(item) && item.type" class="py-0 px-2" @click="openLayerFiltering(item)">
                        <v-icon small color="widgetText" style="opacity: 0.6">
                          mdi-filter
                        </v-icon>
                        <v-list-item-content class="pl-2 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                          {{ labels.filter }}
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="item.children.length < 1 && item.type !== 'wms' && item.type !== 'building' && item.type !== 'scene' && item.type !== 'image' && !rasterLayer(item) && item.type" class="py-0 px-2" @click="openLayerLabeling(item)">
                        <v-icon small color="widgetText" style="opacity: 0.6">
                          mdi-format-letter-case
                        </v-icon>
                        <v-list-item-content class="pl-2 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                          {{ labels.labeling }}
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="item.children.length < 1 && item.type !== 'wms' && item.type !== 'building' && item.type !== 'scene' && item.type !== 'image' && !rasterLayer(item) && item.type" class="py-0 px-2" @click="openLayerSymbology(item)">
                        <v-icon small color="widgetText" style="opacity: 0.6">
                          mdi-symbol
                        </v-icon>
                        <v-list-item-content class="pl-2 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                          {{ labels.symbology }}
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-treeview>
            </v-card-text>
            <v-card color="widget" flat>
              <v-card-text
                v-for="(value, id) in groupItems"
                :key="id"
                class="pa-0">
                <v-treeview
                  ref="tree"
                  v-model="groupSelection[id]"
                  :items="groupItems[id]"
                  selected-color="elements" selection-type="independent"
                  dense selectable return-object
                  @input="toggleLayerVisibility($event, id)">
                  <template #label="{item}">
                    <BaseTooltip
                      v-if="ellipsis"
                      top nudge-top="-33" nudge-right="10">
                      <template #activator="{on, attrs}">
                        <span :class="{'disabledItem': item.disabledItem}" v-bind="attrs" v-on="on">
                          {{ item.name }}
                        </span>
                      </template>
                      <span>
                        {{ item.name }}
                      </span>
                    </BaseTooltip>
                    <div v-else :class="{'disabledItem': item.disabledItem}" style="white-space: pre-wrap">
                      {{ item.name }}
                    </div>
                  </template>

                  <template #append="{item}">
                    <v-menu v-if="!isSmallScreen && item.type !== 'group'" offset-y left>
                      <template #activator="{on, attrs}">
                        <v-icon
                          v-if="item.url && item.children.length < 1 && item.type !== 'wms' "
                          v-show="(layerFilters[item.storeKey] || layerFilters[item.storeKey + '##' + item.id])"
                          :color="( (layerFilters[item.storeKey] || layerFilters[item.storeKey + '##' + item.id])
                            && (layerFilters[item.storeKey] || layerFilters[item.storeKey + '##' + item.id]).isFilterActive) ? 'elements' : 'gray'"
                          x-small>
                          mdi-filter
                        </v-icon>
                        <v-icon
                          v-if="item.url && item.children.length < 1 && item.type !== 'wms' "
                          v-show="(layerLabeling[item.storeKey] || layerLabeling[item.storeKey + '##' + item.id])"
                          :color="( (layerLabeling[item.storeKey] || layerLabeling[item.storeKey + '##' + item.id])
                            && isAnyLayerLabelActive(layerLabeling[item.storeKey] || layerLabeling[item.storeKey + '##' + item.id])) ? 'elements' : 'gray'"
                          small>
                          mdi-format-text-variant
                        </v-icon>
                        <v-icon
                          v-if="item.url && item.children.length < 1 && item.type !== 'wms' "
                          v-show="(layerSymbology[item.storeKey] || layerSymbology[item.storeKey + '##' + item.id])"
                          :color=" (layerSymbology[item.storeKey] || layerSymbology[item.storeKey + '##' + item.id])
                            && isAnyLayerSymbologyActive(layerSymbology[item.storeKey] || layerSymbology[item.storeKey + '##' + item.id]) ? 'elements' : 'gray'"
                          small>
                          mdi-symbol
                        </v-icon>
                        <v-icon
                          v-if="(item.index || item.children < 1) && item.id !== '183b1d72489-layer-3'"
                          v-bind="attrs" v-on="on">
                          mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-list dense class="pa-0">
                        <v-list-item class="pa-0">
                          <v-list-item-content class="pl-0 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                            <div class="mb-3 px-2">
                              {{ labels.transparency }}
                            </div>
                            <template class="pa-0">
                              <v-card-text class="pa-0">
                                <v-slider
                                  ref="slider"
                                  class="pa-4 ml-2 mr-4"
                                  hide-details="true"
                                  :value="item.transparency"
                                  max="1"
                                  min="0"
                                  color="elements"
                                  track-color="elements"
                                  step="0.1"
                                  :thumb-size="22"
                                  thumb-label="always"
                                  @input="changeTransparency($event, item)" />
                                <v-row v-if="item.children.length < 1">
                                  <v-col cols="12" class="py-0">
                                    <v-divider />
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </template>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="item.children.length < 1 && item.type !== 'wms' && item.type !== 'building' && item.type !== 'scene' && item.type !== 'image' && !rasterLayer(item) && item.type" class="py-0 px-2" @click="openAttributeTable(item)">
                          <v-icon small color="widgetText" style="opacity: 0.6">
                            mdi-database-search-outline
                          </v-icon>
                          <v-list-item-content class="pl-2 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                            {{ labels.attributeTable }}
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="item.children.length < 1 && item.type !== 'wms' && item.type !== 'scene' && item.type !== 'image' && !rasterLayer(item) && item.type" class="py-0 px-2" @click="openLayerFiltering(item)">
                          <v-icon small color="widgetText" style="opacity: 0.6">
                            mdi-filter
                          </v-icon>
                          <v-list-item-content class="pl-2 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                            {{ labels.filter }}
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="item.children.length < 1 && item.type !== 'wms' && item.type !== 'scene' && item.type !== 'image' && !rasterLayer(item) && item.type" class="py-0 px-2" @click="openLayerLabeling(item)">
                          <v-icon small color="widgetText" style="opacity: 0.6">
                            mdi-format-letter-case
                          </v-icon>
                          <v-list-item-content class="pl-2 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                            {{ labels.labeling }}
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="item.children.length < 1 && item.type !== 'wms' && item.type !== 'scene' && item.type !== 'image' && !rasterLayer(item) && item.type" class="py-0 px-2" @click="openLayerSymbology(item)">
                          <v-icon small color="widgetText" style="opacity: 0.6">
                            mdi-symbol
                          </v-icon>
                          <v-list-item-content class="pl-2 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                            {{ labels.symbology }}
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-treeview>
              </v-card-text>
              <v-card-text class="pa-0">
                <v-treeview
                  v-model="basemapVisible"
                  :items="basemap"
                  selected-color="elements"
                  selection-type="independent"
                  dense
                  selectable
                  item-disabled="locked"
                  return-object>
                  <template #append>
                    <v-menu v-if="!isSmallScreen " offset-y left>
                      <template #activator="{on, attrs}">
                        <v-icon
                          v-bind="attrs" v-on="on">
                          mdi-dots-vertical
                        </v-icon>
                      </template>

                      <v-list dense class="pa-0">
                        <v-list-item class="py-0 px-2">
                          <v-list-item-content class="pl-0 widgetText--text" :style="{fontSize: '14px', opacity: 0.8}">
                            <div class="mb-3 px-2">
                              {{ labels.transparency }}
                            </div>
                            <template class="pa-0">
                              <v-card-text class="pa-0">
                                <v-slider
                                  ref="slider"
                                  class="pa-4 ml-2 mr-4"
                                  hide-details="true"
                                  :value="basemapTransparency"
                                  max="1"
                                  min="0"
                                  color="elements"
                                  track-color="elements"
                                  step="0.1"
                                  :thumb-size="22"
                                  thumb-label="always"
                                  @input="changeTransparencyBasemap($event)" />
                                <v-row>
                                  <v-col cols="12" class="py-0">
                                    <v-divider />
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </template>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-treeview>
              </v-card-text>
            </v-card>
          </v-card>
        </v-tab-item>
        <v-tab-item
          key="legendToc"
          value="legendToc">
          <div id="legendDiv" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import Legend from '@arcgis/core/widgets/Legend'
import { spEsri } from '../../globals.js'
export default {
  name: 'Toc',
  legendWidget: null,
  data () {
    return {
      configJson: {},
      items: {},
      selectedTab: 'layersToc',
      allServices: [],
      selection: {},
      selectedItem: [],
      oldSelection: {},
      newSelection: [],
      openAll: {},
      ellipsis: true,
      headerHeight: '72px',
      computedHeight: '100px',
      fullHeaderHeight: '104px',
      legendCreated: false,
      basemapVisible: [],
      basemapId: null,
      basemap: [],
      basemapTransparency: 0,
      isViewChanged: false,
      groups: null,
      groupItems: {},
      groupSelection: {},
      oldGroupSelection: {},
    }
  },

  computed: {
    mapScale () {
      return this.$store.getters.getMapScale
    },
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).toc
    },
    viewType () {
      return this.$store.getters.getViewType
    },
    activeTool () {
      return this.$store.getters.getActiveTool
    },
    isSmallScreen () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    layerFilters () {
      return this.$store.getters.getFilters
    },
    layerLabeling () {
      return this.$store.getters.getLabeling
    },
    layerSymbology () {
      return this.$store.getters.getSymbology
    },
    selectedView () {
      return this.$store.getters.getViewObject
    },
    isViewsWidgetForbidden () {
      return this.$store.getters.getForbiddenWidgets?.views
    },
    viewsConfiguration () {
      return this.$store.getters.getConfigJson.widgetConfig.views
    },
    newImageryLayer () {
      return this.$store.getters.getRaster
    },
    newTocItem () {
      return this.$store.getters.getNewTocItem
    },
    hiddenLayers () {
      return this.$store.getters.getConfigJson.appConfig.hiddenLayers ? this.$store.getters.getConfigJson.appConfig.hiddenLayers : []
    },

  },
  watch: {
    mapScale (val) {
      for (const item in this.items) {
        if (!this.items[item]) {
          continue
        }
        this.items[item][0].disabledItem = false
        this.checkScaleForAllChildren(this.items[item][0])
      }
      this.items = { ...this.items }
    },
    labels (value) {
      const newOBasemapObject = Object.assign({}, this.basemap[0])
      newOBasemapObject.name = value.basemap
      this.$set(this.basemap, 0, newOBasemapObject)
    },
    basemapVisible (value) {
      if (value.length === 0) {
        this.changeBasemapOpacity(0)
        this.selected = null
      } else {
        this.changeBasemapOpacity(1 - this.basemapTransparency)
        this.selected = this.basemapId
      }
    },
    newImageryLayer (newCount) {
      if (newCount) {
        const imagaryLayer = spEsri.imageryLayers[newCount.key]

        this.allServices.push(imagaryLayer)
        const layerId = imagaryLayer.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false

        const element = {
          id: imagaryLayer.id,
          name: imagaryLayer.title,
          children: [],
          type: 'image',
          storeKey: newCount.key,
          url: imagaryLayer.url,
          index: 1,
          transparency: 0,
        }
        if (imagaryLayer.visible) {
          this.selection[imagaryLayer.id].push(element)
        }
        this.items[imagaryLayer.id].push(element)
        this.oldSelection[imagaryLayer.id] = this.selection[imagaryLayer.id]
      }

      this.$forceUpdate()
    },
    newTocItem (newCount) {
      if (newCount.type === 'Dynamic') {
        let mapScale = null
        if (this.viewType === '3d') {
          mapScale = spEsri.sceneView.scale
        } else {
          mapScale = spEsri.mapView.scale
        }
        const mILayer = spEsri.mapImageLayers[newCount.key]
        this.allServices.push(mILayer)
        const layerId = mILayer.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false

        const elementRoot = {
          id: mILayer.id,
          key: newCount.key,
          name: mILayer.title,
          children: [],
          checked: mILayer.visible,
          root: true,
          url: mILayer.url,
          transparency: 0,
          disabledItem: false,
          minScale: mILayer.minScale,
          maxScale: mILayer.maxScale,
          index: 1,

        }
        if (mILayer.visible === true) {
          this.selection[mILayer.id].push(elementRoot)
        }
        this.items[mILayer.id].push(elementRoot)
        for (const dl of mILayer.sourceJSON.layers) {
          if (dl.parentLayerId === -1) {
            const element = {
              id: dl.id,
              name: dl.name,
              type: 'mapImage',
              storeKey: newCount.key,
              url: mILayer.url + '/' + dl.id,
              children: [],
              disabledItem: (dl.minScale === 0 && dl.maxScale === 0) ? false : ((mapScale < dl.maxScale && dl.minScale === 0) || (dl.maxScale !== 0 && dl.minScale !== 0 && (mapScale < dl.maxScale || mapScale > dl.minScale)) || (dl.maxScale === 0 && mapScale > dl.minScale)),
              minScale: dl.minScale,
              maxScale: dl.maxScale,
            }
            const containInPrivilege = mILayer.allSublayers.items.some(e => e.id === dl.id)
            const result = mILayer.allSublayers.items.find(obj => obj.id === dl.id)
            if (dl.subLayerIds === null && containInPrivilege) {
              if (result?.visible === true) {
                element.checked = true
                this.selection[mILayer.id].push(element)
              }
              this.items[mILayer.id][0].children.push(element)
            }
            if (dl.subLayerIds) {
              if (result?.visible === true) {
                element.checked = true
                this.selection[mILayer.id].push(element)
              }
              this.items[mILayer.id][0].children.push(element)
            }
          } else {
            const disabledGroupLayers = this.configJson.operationalMaps.find(e => e.layerId === mILayer.id)?.disabledGroupLayers
            if (!(disabledGroupLayers?.includes(dl.id))) {
              const elementChild = {
                id: dl.id,
                name: dl.name,
                type: 'mapImage',
                storeKey: newCount.key,
                url: mILayer.url + '/' + dl.id,
                children: [],
                disabledItem: (dl.minScale === 0 && dl.maxScale === 0) ? false : ((mapScale < dl.maxScale && dl.minScale === 0) || (dl.maxScale !== 0 && dl.minScale !== 0 && (mapScale < dl.maxScale || mapScale > dl.minScale)) || (dl.maxScale === 0 && mapScale > dl.minScale)),
                minScale: dl.minScale,
                maxScale: dl.maxScale,
              }
              this.pushInParent(
                elementChild,
                dl.parentLayerId,
                mILayer.id,
                dl.subLayerIds,
                mILayer.allSublayers.items,
                this.items[mILayer.id]
              )
            }
          }
        }
        this.oldSelection[mILayer.id] = this.selection[mILayer.id]
      } else if (newCount.type === 'Feature Layer') {
        let mapScale = null
        if (this.viewType === '3d') {
          mapScale = spEsri.sceneView.scale
        } else {
          mapScale = spEsri.mapView.scale
        }
        const featureLayer = spEsri.featureLayers[newCount.key]

        this.allServices.push(featureLayer)
        const layerId = featureLayer.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false
        const element = {
          id: featureLayer.id,
          name: featureLayer.title,
          type: 'feature',
          index: 1,
          storeKey: newCount.key,
          url: featureLayer.url + '/' + featureLayer.layerId,
          children: [],
          disabledItem: (featureLayer.minScale === 0 && featureLayer.maxScale === 0) ? false : ((mapScale < featureLayer.maxScale && featureLayer.minScale === 0) || ((mapScale < featureLayer.maxScale || mapScale > featureLayer.minScale) && featureLayer.maxScale !== 0 && featureLayer.minScale !== 0) || (featureLayer.maxScale === 0 && mapScale > featureLayer.minScale)),
          minScale: featureLayer.minScale,
          maxScale: featureLayer.maxScale,
        }
        if (featureLayer.visible) {
          this.selection[featureLayer.id].push(element)
        }
        this.items[featureLayer.id].push(element)
        this.oldSelection[featureLayer.id] = this.selection[featureLayer.id]
      } else if (newCount.type === 'WMTS') {
        const wmtsLayer = spEsri.wmtsLayers[newCount.key]

        this.allServices.push(wmtsLayer)
        const layerId = wmtsLayer.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false
        const element = {
          id: wmtsLayer.id,
          name: wmtsLayer.title,
          type: 'wmts',
          index: 1,
          storeKey: newCount.key,
          url: wmtsLayer.url + '/' + wmtsLayer.layerId,
          children: [],

        }
        if (wmtsLayer.visible) {
          this.selection[wmtsLayer.id].push(element)
        }
        this.items[wmtsLayer.id].push(element)
        this.oldSelection[wmtsLayer.id] = this.selection[wmtsLayer.id]
      } else if (newCount.type === 'WMS') {
        const wmsLayer = spEsri.wmsLayers[newCount.key]

        this.allServices.push(wmsLayer)
        const layerId = wmsLayer.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false
        const elementRoot = {
          id: wmsLayer.id,
          key: newCount.key,
          name: wmsLayer.title,
          children: [],
          checked: wmsLayer.visible,
          root: true,
          url: wmsLayer.url,
          transparency: 0,
          disabledItem: false,
          minScale: wmsLayer.minScale,
          maxScale: wmsLayer.maxScale,
          index: 1,

        }
        if (wmsLayer.visible === true) {
          this.selection[wmsLayer.id].push(elementRoot)
        }
        this.items[wmsLayer.id].push(elementRoot)
        if (wmsLayer?.resourceInfo?.layers) {
          for (const dl of wmsLayer.resourceInfo.layers) {
            if (dl.parentLayerId === -1) {
              const element = {
                id: dl.id,
                name: dl.name,
                type: 'wms',
                storeKey: newCount.key,
                url: wmsLayer.url + '/' + dl.id,
                children: [],
                disabledItem: false,
                minScale: dl.minScale,
                maxScale: dl.maxScale,
              }
              const result = wmsLayer.allSublayers.items.find(obj => obj.id === dl.id)
              if (result) {
                result.id = dl.id
              }
              if (result.sublayers?.items.length || result.sublayers === null) {
                if (result?.visible === true) {
                  element.checked = true
                  this.selection[wmsLayer.id].push(element)
                }
                this.items[wmsLayer.id][0].children.push(element)
              }
            } else {
              const elementChild = {
                id: dl.id,
                name: dl.name,
                type: 'wms',
                storeKey: newCount.key,
                url: wmsLayer.url + '/' + dl.id,
                children: [],
              }
              const result = wmsLayer.allSublayers.items.find(obj => obj.id === dl.id)
              this.pushInParent(
                elementChild,
                dl.parentLayerId,
                wmsLayer.id,
                result.sublayers,
                wmsLayer.allSublayers.items,
                this.items[wmsLayer.id]
              )
            }
          }
        }
        this.oldSelection[wmsLayer.id] = this.selection[wmsLayer.id]
      }

      this.$forceUpdate()
    },
    async viewType (newCount) {
      // add/remove 3d service from toc when viewType is 3d/2d
      if (newCount === '3d') {
        const sceneLayers = spEsri.sceneLayers
        const buildingLayers = spEsri.buildingLayers
        for (const service of this.configJson.operationalMaps) {
          if (service.type === 'scene') {
            const groups = this.configJson.widgetConfig.toc.groups
            if (groups) {
              if (Object.values(groups).find(group => group.elements.includes(service.ID))) {
                continue
              }
            }

            const sl1 = sceneLayers[service.ID]
            this.allServices.push(sl1.sceneLayer)
            const layerId = sl1.sceneLayer.id
            this.items[layerId] = []
            this.selection[layerId] = []
            this.openAll[layerId] = false
          }
          if (service.type === 'building') {
            const buildingLayer = buildingLayers[service.ID].buildingLayer
            this.allServices.push(buildingLayer)
            const layerIdB = buildingLayer.id
            this.items[layerIdB] = []
            this.selection[layerIdB] = []
            const layer = this.configJson.widgetConfig.toc?.services[service.ID]
            this.openAll[layerIdB] = layer?.expanded ? layer.expanded : false
          }
        }
        for (const key in sceneLayers) {
          const groups = this.configJson.widgetConfig.toc.groups
          if (groups) {
            if (Object.values(groups).find(group => group.elements.includes(key))) {
              continue
            }
          }
          const sl = sceneLayers[key]
          const element = {
            id: sl.sceneLayer.id,
            name: sl.sceneLayer.title,
            children: [],
            type: 'scene',
            storeKey: key,
            url: sl.sceneLayer.url + '/' + sl.sceneLayer.layerId,
            index: 1,
            transparency: 0,
          }
          if (sl.sceneLayer.visible) {
            this.selection[sl.sceneLayer.id].push(element)
          }
          this.items[sl.sceneLayer.id].push(element)
          this.oldSelection[sl.sceneLayer.id] = this.selection[sl.sceneLayer.id]
        }
        for (const key in buildingLayers) {
          const blLayer = buildingLayers[key].buildingLayer
          const elementRoot = {
            id: blLayer.id,
            key: key,
            type: 'building',
            name: blLayer.title,
            children: [],
            checked: blLayer.visible,
            root: true,
            url: blLayer.url,
            transparency: 0,
          }
          if (blLayer.visible === true) {
            this.selection[blLayer.id].push(elementRoot)
          }
          this.items[blLayer.id].push(elementRoot)
          const buildingComponent = blLayer.sublayers.items.filter(e => e.type === 'building-component')

          await buildingComponent[0].load()

          if (buildingComponent[0]) {
            const element = {
              id: buildingComponent[0].id,
              name: buildingComponent[0].title,
              storeKey: key,
              children: [],
            }
            if (buildingComponent.visible) {
              element.checked = true
              this.selection[blLayer.id].push(element)
            }
            this.items[blLayer.id][0].children.push(element)
          }
          const sublayers = blLayer.sublayers.items.filter(e => e.type === 'building-group')

          for (const bl of sublayers) {
            const element = {
              id: bl.id,
              name: bl.title,
              storeKey: key,
              children: [],
            }
            this.addChildren(element, bl.sublayers, blLayer.id)
            if (bl.visible) {
              element.checked = true
              this.selection[blLayer.id].push(element)
            }
            this.items[blLayer.id][0].children.push(element)
          }
        }
        const groups = this.configJson.widgetConfig.toc.groups
        if (groups) {
          for (const key of Object.keys(groups)) {
            if (groups[key].root && groups[key].is3d) {
              this.groupItems[key] = []
              this.groupSelection[key] = []

              const element = {
                id: key,
                key: key,
                name: groups[key].name,
                children: [],
                checked: !groups[key].hidden,
                root: true,
                type: 'group',
                is3d: groups[key].is3d,
              }
              element.children = this.buildGroup(groups[key].elements, groups, element)
              this.groupItems[key].push(element)
              this.groupSelection[key] = this.flattenGroupChildren(element)
              const filteredGroupSelection = this.groupSelection[key].filter(selection => selection.type === 'group' || (selection.type !== 'group' && selection.checked))
              this.oldGroupSelection[key] = [...filteredGroupSelection]
            }
          }
        }

        if (this.$options.legendWidget) {
          this.$options.legendWidget.view = spEsri.sceneView
        }
        this.$forceUpdate()
      } else {
        debugger
        for (const key in this.groupItems) {
          if (this.groupItems[key][0].is3d) {
            delete this.groupItems[key]
          }
        }

        const sceneLayers = spEsri.sceneLayers
        for (const key in sceneLayers) {
          const sl = sceneLayers[key]
          delete this.items[sl.sceneLayer.id]
        }
        const buildingLayers = spEsri.buildingLayers
        for (const key in buildingLayers) {
          const bl = buildingLayers[key]
          delete this.items[bl.buildingLayer.id]
        }
        if (this.$options.legendWidget) {
          this.$options.legendWidget.view = spEsri.mapView
        }
        this.$forceUpdate()
      }
    },
    activeTool (newValue) {
      if (newValue === 'toc') {
        this.resize()
      }
    },
  },
  created () {
    if (this.$store.getters.getIsViewChanged) {
      this.isViewChanged = true
      this.$store.dispatch('setIsViewChanged', false)
    }
    let mapScale = null
    if (this.viewType === '3d') {
      mapScale = spEsri.sceneView.scale
    } else {
      mapScale = spEsri.mapView.scale
    }
    const mapImageLayers = spEsri.mapImageLayers
    const featureLayers = spEsri.featureLayers
    const imageryLayers = spEsri.imageryLayers
    const wmsLayers = spEsri.wmsLayers
    const sceneLayers = spEsri.sceneLayers
    const portalLayers = spEsri.portalLayers
    const buildingLayers = spEsri.buildingLayers
    this.configJson = this.$store.getters.getConfigJson
    this.items = {}
    this.ellipsis = this.configJson.widgetConfig.toc.ellipsis
    // portal items
    if (portalLayers.length > 0) {
      for (const portalLayer of portalLayers.reverse()) {
        this.allServices.push(portalLayer)
        const layerId = portalLayer.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false
      }
      portalLayers.reverse()
    }
    // each service is unique tree (this.items - all items of tree, this.selection - selected items of items, this.openAll - expanded/collapsed indicator)
    for (const service of this.configJson.operationalMaps) {
      if (service.type === 'dynamic' && mapImageLayers[service.ID] && this.configJson.widgetConfig.toc?.services[service.ID]) {
        const mapImageLayer = mapImageLayers[service.ID]
        this.allServices.push(mapImageLayer)
        const layerId = mapImageLayer.id
        service.layerId = layerId
        this.items[layerId] = []
        this.selection[layerId] = []
        const layer = this.configJson.widgetConfig.toc?.services[service.ID]
        this.openAll[layerId] = layer?.expanded ? layer.expanded : false
      } else if (service.type === 'wms' && wmsLayers[service.ID] && this.configJson.widgetConfig.toc?.services[service.ID]) {
        const wmsLayer = wmsLayers[service.ID]
        this.allServices.push(wmsLayer)
        const layerId = wmsLayer.id
        service.layerId = layerId
        this.items[layerId] = []
        this.selection[layerId] = []
        const layer = this.configJson.widgetConfig.toc?.services[service.ID]
        this.openAll[layerId] = layer?.expanded ? layer.expanded : false
      } else if (service.type === 'building' && buildingLayers[service.ID] && this.viewType === '3d' && this.configJson.widgetConfig.toc?.services[service.ID]) {
        const buildingLayer = buildingLayers[service.ID].buildingLayer
        this.allServices.push(buildingLayer)
        const layerId = buildingLayer.id
        service.layerId = layerId
        this.items[layerId] = []
        this.selection[layerId] = []
        const layer = this.configJson.widgetConfig.toc?.services[service.ID]
        this.openAll[layerId] = layer?.expanded ? layer.expanded : false
      } else if (service.type === 'feature' && featureLayers[service.ID] && this.configJson.widgetConfig.toc?.services[service.ID]) {
        const groups = this.configJson.widgetConfig.toc.groups
        if (groups) {
          if (Object.values(groups).find(group => group.elements.includes(service.ID))) {
            continue
          }
        }
        const fl = featureLayers[service.ID]
        this.allServices.push(fl)
        const layerId = fl.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false
      } else if (service.type === 'image' && imageryLayers[service.ID] && this.configJson.widgetConfig.toc?.services[service.ID]) {
        const il = imageryLayers[service.ID]
        this.allServices.push(il)
        const layerId = il.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false
      } else if (service.type === 'scene' && this.viewType === '3d' && sceneLayers[service.ID] && this.configJson.widgetConfig.toc?.services[service.ID]) {
        const groups = this.configJson.widgetConfig.toc.groups
        if (groups) {
          if (Object.values(groups).find(group => group.elements.includes(service.ID))) {
            continue
          }
        }

        const sl = sceneLayers[service.ID]
        this.allServices.push(sl.sceneLayer)
        const layerId = sl.sceneLayer.id
        this.items[layerId] = []
        this.selection[layerId] = []
        this.openAll[layerId] = false
      }
    }
    for (const key in wmsLayers) {
      const wmsLayer = wmsLayers[key]
      this.allServices.push(wmsLayer)
      const layerId = wmsLayer.id
      this.items[layerId] = []
      this.selection[layerId] = []
      this.openAll[layerId] = false
      const elementRoot = {
        id: wmsLayer.id,
        key: key,
        name: wmsLayer.title,
        children: [],
        checked: wmsLayer.visible,
        root: true,
        type: 'wms',
        url: wmsLayer.url,
        transparency: 0,
        disabledItem: false,
        minScale: wmsLayer.minScale,
        maxScale: wmsLayer.maxScale,
        index: 1,
      }
      if (wmsLayer.visible === true) {
        this.selection[wmsLayer.id].push(elementRoot)
      }
      this.items[wmsLayer.id].push(elementRoot)
      if (wmsLayer?.resourceInfo?.layers) {
        for (const dl of wmsLayer.resourceInfo.layers) {
          if (dl.parentLayerId === -1) {
            const element = {
              id: dl.id,
              name: dl.title,
              type: 'wms',
              storeKey: key,
              url: wmsLayer.url + '/' + dl.id,
              children: [],
              disabledItem: false,
              minScale: dl.minScale,
              maxScale: dl.maxScale,
            }
            const result = wmsLayer.allSublayers.items.find(obj => obj.name === dl.name)
            if (result) {
              result.id = dl.id
            }
            if (result?.sublayers?.items.length || result?.sublayers === null || result?.sublayers === undefined) {
              if (result?.visible === true) {
                element.checked = true
                this.selection[wmsLayer.id].push(element)
              }
              this.items[wmsLayer.id][0].children.push(element)
            }
          } else {
            const elementChild = {
              id: dl.id,
              name: dl.name,
              type: 'wms',
              storeKey: key,
              url: wmsLayer.url + '/' + dl.id,
              children: [],
            }
            const result = wmsLayer.allSublayers.items.find(obj => obj.id === dl.id)
            this.pushInParent(
              elementChild,
              dl.parentLayerId,
              wmsLayer.id,
              result.sublayers,
              wmsLayer.allSublayers.items,
              this.items[wmsLayer.id]
            )
          }
        }
      }
      this.oldSelection[wmsLayer.id] = this.selection[wmsLayer.id]

      this.$forceUpdate()
    }
    this.$forceUpdate()

    // dynamic service -tree element initialization
    for (const key in mapImageLayers) {
      if (this.configJson.widgetConfig.toc?.services[key]) {
        const mILayer = mapImageLayers[key]
        const elementRoot = {
          id: mILayer.id,
          key: key,
          name: mILayer.title,
          children: [],
          checked: mILayer.visible,
          root: true,
          url: mILayer.url,
          transparency: 0,
          disabledItem: false,
          minScale: mILayer.minScale,
          maxScale: mILayer.maxScale,
        }
        if (mILayer.visible === true) {
          this.selection[mILayer.id].push(elementRoot)
        }
        this.items[mILayer.id].push(elementRoot)
        for (const dl of mILayer.sourceJSON.layers) {
          if (dl.parentLayerId === -1) {
            const element = {
              id: dl.id,
              name: dl.name,
              type: 'mapImage',
              storeKey: key,
              url: mILayer.url + '/' + dl.id,
              children: [],
              disabledItem: (dl.minScale === 0 && dl.maxScale === 0) ? false : ((mapScale < dl.maxScale && dl.minScale === 0) || (dl.maxScale !== 0 && dl.minScale !== 0 && (mapScale < dl.maxScale || mapScale > dl.minScale)) || (dl.maxScale === 0 && mapScale > dl.minScale)),
              minScale: dl.minScale,
              maxScale: dl.maxScale,
            }
            const containInPrivilege = mILayer.allSublayers.items.some(e => e.id === dl.id)
            const result = mILayer.allSublayers.items.find(obj => obj.id === dl.id)
            if (dl.subLayerIds === null && containInPrivilege) {
              if (result?.visible === true) {
                element.checked = true
                this.selection[mILayer.id].push(element)
              }
              this.items[mILayer.id][0].children.push(element)
            }
            if (dl.subLayerIds) {
              if (result?.visible === true) {
                element.checked = true
                this.selection[mILayer.id].push(element)
              }
              this.items[mILayer.id][0].children.push(element)
            }
          } else {
            const disabledGroupLayers = this.configJson.operationalMaps.find(e => e.layerId === mILayer.id)?.disabledGroupLayers
            if (!(disabledGroupLayers?.includes(dl.id))) {
              const elementChild = {
                id: dl.id,
                name: dl.name,
                type: 'mapImage',
                storeKey: key,
                url: mILayer.url + '/' + dl.id,
                children: [],
                disabledItem: (dl.minScale === 0 && dl.maxScale === 0) ? false : ((mapScale < dl.maxScale && dl.minScale === 0) || (dl.maxScale !== 0 && dl.minScale !== 0 && (mapScale < dl.maxScale || mapScale > dl.minScale)) || (dl.maxScale === 0 && mapScale > dl.minScale)),
                minScale: dl.minScale,
                maxScale: dl.maxScale,
              }
              this.pushInParent(
                elementChild,
                dl.parentLayerId,
                mILayer.id,
                dl.subLayerIds,
                mILayer.allSublayers.items,
                this.items[mILayer.id]
              )
            }
          }
        }
      }
    }
    // delete element without privileges
    for (const it in this.items) {
      if (this.items[it][0]?.type !== 'wms') {
        let layerInPrivilege = []

        for (const key in mapImageLayers) {
          const mILayer = mapImageLayers[key]
          if (mILayer.id === it) {
            layerInPrivilege = mILayer.allSublayers.items
          }
        }
        const treeDepth = this.depth(this.items[it], 0)
        for (const lay of this.items[it]) {
          for (let i = 0; i < treeDepth; i++) {
            for (const child of lay.children) {
              if (this.deleteChild(child, layerInPrivilege)) {
                const idOfChild = child.id
                lay.children = lay.children.filter(item => item.id !== idOfChild)
              }
            }
          }
        }
      }
    }
    // set check to group layer
    for (const it in this.items) {
      this.checkAllParent(this.items[it], it)
    }

    // set visible of child to false if any parent are unvisible
    for (const it in this.items) {
      this.checkAllChild(this.items[it], it)
    }

    // feature layer - initialization
    for (const key in featureLayers) {
      if (this.configJson.widgetConfig.toc?.services[key]) {
        const groups = this.configJson.widgetConfig.toc.groups
        if (groups) {
          if (Object.values(groups).find(group => group.elements.includes(key))) {
            continue
          }
        }

        const featureLayer = featureLayers[key]
        const element = {
          id: featureLayer.id,
          name: featureLayer.title,
          type: 'feature',
          storeKey: key,
          url: featureLayer.url + '/' + featureLayer.layerId,
          children: [],
          disabledItem: (featureLayer.minScale === 0 && featureLayer.maxScale === 0) ? false : ((mapScale < featureLayer.maxScale && featureLayer.minScale === 0) || (featureLayer.maxScale !== 0 && featureLayer.minScale !== 0 && (mapScale < featureLayer.maxScale || mapScale > featureLayer.minScale)) || (featureLayer.maxScale === 0 && mapScale > featureLayer.minScale)),
          minScale: featureLayer.minScale,
          maxScale: featureLayer.maxScale,
        }
        if (featureLayer.visible) {
          this.selection[featureLayer.id].push(element)
        }
        this.items[featureLayer.id].push(element)
      }
    }
    // portal layer - initialization
    for (const pl of portalLayers) {
      const element = {
        id: pl.id,
        name: pl.title,
        children: [],
      }
      if (pl.visible) {
        this.selection[pl.id].push(element)
      }
      this.items[pl.id].push(element)
    }
    // image layer - initialization
    for (const key in imageryLayers) {
      if (this.configJson.widgetConfig.toc?.services[key]) {
        const il = imageryLayers[key]
        const element = {
          id: il.id,
          name: il.title,
          children: [],
          url: il.url,
        }
        if (il.visible) {
          this.selection[il.id].push(element)
        }
        this.items[il.id].push(element)
      }
    }
    if (this.viewType === '3d') {
      for (const key in buildingLayers) {
        if (this.configJson.widgetConfig.toc?.services[key]) {
          const blLayer = buildingLayers[key].buildingLayer
          const elementRoot = {
            id: blLayer.id,
            key: key,
            type: 'building',
            name: blLayer.title,
            children: [],
            checked: blLayer.visible,
            root: true,
            url: blLayer.url,
            transparency: 0,
          }
          if (blLayer.visible === true) {
            this.selection[blLayer.id].push(elementRoot)
          }
          this.items[blLayer.id].push(elementRoot)
          const buildingComponent = blLayer.sublayers.items.filter(e => e.type === 'building-component')
          if (buildingComponent[0]) {
            const element = {
              id: buildingComponent[0].id,
              name: buildingComponent[0].title,
              storeKey: key,
              children: [],
            }
            if (buildingComponent[0].visible) {
              element.checked = true
              this.selection[blLayer.id].push(element)
            }
            this.items[blLayer.id][0].children.push(element)
          }
          const sublayers = blLayer.sublayers.items.filter(e => e.type === 'building-group')

          for (const bl of sublayers) {
            const element = {
              id: bl.id,
              name: bl.title,
              storeKey: key,
              children: [],
            }
            this.addChildren(element, bl.sublayers, blLayer.id)
            if (bl.visible) {
              element.checked = true
              this.selection[blLayer.id].push(element)
            }
            this.items[blLayer.id][0].children.push(element)
          }
        }
      }
      for (const key in sceneLayers) {
        if (this.configJson.widgetConfig.toc?.services[key]) {
          const groups = this.configJson.widgetConfig.toc.groups
          if (groups) {
            if (Object.values(groups).find(group => group.elements.includes(key))) {
              continue
            }
          }
          const sl = sceneLayers[key]
          const element = {
            id: sl.sceneLayer.id,
            name: sl.sceneLayer.title,
            type: 'scene',
            storeKey: key,
            url: sl.sceneLayer.url + '/' + sl.sceneLayer.layerId,
            children: [],
            transparency: 0,
            index: 1,
          }
          if (sl.sceneLayer.visible) {
            this.selection[sl.sceneLayer.id].push(element)
          }
          this.items[sl.sceneLayer.id].push(element)
          this.oldSelection[sl.sceneLayer.id] = this.selection[sl.sceneLayer.id]
        }
      }
    }
    for (const s in this.selection) {
      this.oldSelection[s] = this.selection[s]
    }

    for (const key in this.items) {
      for (const service of this.configJson.operationalMaps) {
        if (service.mapURL === this.items[key][0].url) {
          this.items[key][0].transparency = 1 - service.opacity
          this.items[key][0].index = 1
          break
        }
      }
    }

    for (const key in this.items) {
      this.checkAllChildrenForItems(this.items[key][0])
    }

    const groups = this.configJson.widgetConfig.toc.groups
    if (groups) {
      for (const key of Object.keys(groups)) {
        if (groups[key].root && ((this.viewType === '3d' && groups[key].is3d) || (this.viewType === '2d' && !groups[key].is3d))) {
          this.groupItems[key] = []
          this.groupSelection[key] = []

          const element = {
            id: key,
            key: key,
            name: groups[key].name,
            children: [],
            checked: !groups[key].hidden,
            root: true,
            type: 'group',
            is3d: groups[key].is3d,
          }
          element.children = this.buildGroup(groups[key].elements, groups, element)
          console.log(element)
          this.groupItems[key].push(element)
          this.groupSelection[key] = this.flattenGroupChildren(element)
          const filteredGroupSelection = this.groupSelection[key].filter(selection => (selection.type === 'group' && !selection.root) || (selection.type === 'group' && selection.checked && selection.root) || (selection.type !== 'group' && selection.checked))
          this.groupSelection[key] = [...filteredGroupSelection]
          this.oldGroupSelection[key] = [...filteredGroupSelection]
        }
      }
    }
  },

  mounted () {
    this.basemap = [{
      locked: false,
      checked: true,
      name: this.labels.basemap,
      children: [],
      root: true,
    }]

    this.basemapVisible = this.basemap
    this.basemapId = spEsri.map.basemap.id

    const observer = new MutationObserver(() => {
      const el = document.getElementById('legendDiv')
      if (document.contains(el)) {
        this.getLegend()
        observer.disconnect()
      }
    })
    observer.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    })

    const observer2 = new MutationObserver(() => {
      for (const el of this.hiddenLayers) {
        const targetElement = this.getElementByTextContent(el)
        if (targetElement) {
          targetElement.style.display = 'none'
        }
      }
      // observer2.disconnect()
    })
    observer2.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    })
    this.legendWidget = null
    this.legendCreated = false
  },
  methods: {
    rasterLayer (item) {
      return spEsri.rasterLayers.includes(item.url)
    },
    getElementByTextContent (text) {
      const elements = document.querySelectorAll('div')
      for (const element of elements) {
        if (element.textContent.trim() === text) {
          return element
        }
      }
      return null
    },
    toggleLayerVisibility (newGroupSelection, key) {
      const addedItem = newGroupSelection.filter(newItem =>
        !this.oldGroupSelection[key].some(oldItem => oldItem.id === newItem.id)
      )
      const removedItem = this.oldGroupSelection[key].filter(oldItem =>
        !newGroupSelection.some(newItem => newItem.id === oldItem.id)
      )
      if (addedItem.length > 0) {
        addedItem[0].checked = true
      } else if (removedItem.length > 0) {
        removedItem[0].checked = false
      }

      this.oldGroupSelection[key] = [...newGroupSelection]
      this.updateVisibility(this.groupItems[key][0])
    },
    flattenGroupChildren (el) {
      let result = []
      result.push(el)
      if (el.children && Array.isArray(el.children) && el.children.length > 0) {
        for (const child of el.children) {
          result = [...result, ...this.flattenGroupChildren(child)]
        }
      }
      return result
    },
    updateVisibility (node, parentVisibility = true) {
      const isVisible = node.checked && parentVisibility

      if (spEsri.sceneLayers[node.storeKey]) {
        spEsri.sceneLayers[node.storeKey].sceneLayer.visible = isVisible
      } else if (spEsri.featureLayers[node.storeKey]) {
        spEsri.featureLayers[node.storeKey].visible = isVisible
      }
      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          this.updateVisibility(child, isVisible)
        }
      }
    },

    buildGroup (elements, groups, element) {
      return elements.map(el => {
        if (spEsri.sceneLayers[el]) {
          return {
            id: spEsri.sceneLayers[el].sceneLayer.id,
            name: spEsri.sceneLayers[el].sceneLayer.title,
            type: 'scene',
            storeKey: el,
            checked: spEsri.sceneLayers[el].sceneLayer.visible,
            url: spEsri.sceneLayers[el].sceneLayer.url + '/' + spEsri.sceneLayers[el].sceneLayer.layerId,
            children: [],
          }
        } else if (spEsri.featureLayers[el]) {
          const visible = spEsri.featureLayers[el].visible
          if (!element?.checked) {
            spEsri.featureLayers[el].visible = false
          }
          return {
            id: spEsri.featureLayers[el].id,
            name: spEsri.featureLayers[el].title,
            type: 'feature',
            storeKey: el,
            url: spEsri.featureLayers[el].url + '/' + spEsri.featureLayers[el].layerId,
            children: [],
            checked: visible,
            disabledItem: (spEsri.featureLayers[el].minScale === 0 && spEsri.featureLayers[el].maxScale === 0)
              ? false : ((this.mapScale < spEsri.featureLayers[el].maxScale && spEsri.featureLayers[el].minScale === 0) || (spEsri.featureLayers[el].maxScale !== 0 && spEsri.featureLayers[el].minScale !== 0 && (this.mapScale < spEsri.featureLayers[el].maxScale || this.mapScale > spEsri.featureLayers[el].minScale)) || (spEsri.featureLayers[el].maxScale === 0 && this.mapScale > spEsri.featureLayers[el].minScale)),
            minScale: spEsri.featureLayers[el].minScale,
            maxScale: spEsri.featureLayers[el].maxScale,
          }
        } else if (groups[el]) {
          return {
            id: el,
            key: el,
            name: groups[el].name,
            checked: true,
            type: 'group',
            children: this.buildGroup(groups[el].elements, groups),
          }
        }
      }).filter(el => !!el)
    },
    addChildren (element, children, id) {
      if (children?.length) {
        for (const child of children) {
          const elem = {
            id: child.id,
            name: child.title,
            children: [],
          }
          if (child.visible) {
            elem.checked = true
            this.selection[id].push(elem)
          }
          element.children.push(elem)
          this.addChildren(elem, child.sublayers, id)
        }
      } else {
        return false
      }
    },
    checkAllChildrenForItems (currentItem) {
      if (!currentItem.children || currentItem.children.length === 0) {
        return
      }
      for (const item of currentItem.children) {
        if (item.children && item.children.length > 0) {
          item.disabledItem = false
        }
        this.checkAllChildrenForItems(item)
      }
    },
    checkScaleForAllChildren (currentItem) {
      if (currentItem.type === 'feature') {
        if (currentItem.minScale === 0 && currentItem.maxScale === 0) {
          currentItem.disabledItem = false
        } else if ((this.mapScale < currentItem.maxScale && currentItem.minScale === 0) || (currentItem.maxScale !== 0 && currentItem.minScale !== 0 && (this.mapScale < currentItem.maxScale || this.mapScale > currentItem.minScale)) || (currentItem.maxScale === 0 && this.mapScale > currentItem.minScale)) {
          currentItem.disabledItem = true
        } else {
          currentItem.disabledItem = false
        }
      }
      // if currentItem has no children
      if (!currentItem.children || currentItem.children.length === 0) {
        return
      }
      // if currentItem has children
      for (const item of currentItem.children) {
        if (item.children && item.children.length > 0) {
          item.disabledItem = false
        } else if (item.minScale === 0 && item.maxScale === 0) {
          item.disabledItem = false
        } else if ((this.mapScale < item.maxScale && item.minScale === 0) || ((this.mapScale < item.maxScale || this.mapScale > item.minScale) && item.maxScale !== 0 && item.minScale !== 0) || (item.maxScale === 0 && this.mapScale > item.minScale)) {
          item.disabledItem = true
        } else {
          item.disabledItem = false
        }

        this.checkScaleForAllChildren(item)
      }
    },
    expandAll () {
      for (const tree of this.$refs.tree) {
        tree.updateAll(true)
      }
    },
    collapseAll () {
      for (const tree of this.$refs.tree) {
        tree.updateAll(false)
      }
    },
    addView () {
      this.$emit('open-add-view')
    },
    addService () {
      this.$emit('open-add-service')
    },
    // is Tree expanded or collapsed
    isOpen (name) {
      return this.openAll[name] ? this.openAll[name] : false
    },
    // check for dynamic layers
    checkAllParent (items, it) {
      for (const item of items) {
        if (item.children.length > 0) {
          if (item.root === true) {
            if (item.checked === true) {
              // this.selection[it].push(item)
            }
          } else if (this.isViewChanged) {
            item.checked = true
            this.selection[it].push(item)
          } else {
            const hiddenGroupLayers = this.configJson.operationalMaps.find(e => e.layerId === it)?.hiddenGroupLayers
            if (!(hiddenGroupLayers?.includes(item.id))) {
              item.checked = true
              this.selection[it].push(item)
            }
          }
          this.checkAllParent(item.children, it)
        }
      }
    },
    checkAllChild (items, it) {
      for (const item of items) {
        if (item.children.length === 0) {
          if (!(this.isParentChecked(item, this.items[it]))) {
            const selectedService = this.allServices.find(obj => obj.id === it)
            const layerToChange = selectedService.allSublayers.items.find(obj => obj.id === item.id)
            layerToChange.visible = false
          }
        } else {
          this.checkAllChild(item.children, it)
        }
      }
    },
    // depth of tree
    depth (items, currentDepth) {
      let result = currentDepth + 1
      for (const item in items) {
        result = this.maximum(result, this.depth(item.children, result + 1))
      }
      return result
    },
    maximum (a, b) {
      return a >= b ? a : b
    },
    close () {
      this.$store.dispatch('unSetActiveTool')
    },
    // delete element without privileges
    deleteChild (child, privilege) {
      if (child.children.length === 0) {
        return !privilege.some(e => e.id === child.id)
      }
      for (const ch of child.children) {
        ch.deleteParametar = false
        ch.deleteParametar = this.deleteChild(ch, privilege)
      }
      for (const ch1 of child.children) {
        if (ch1.deleteParametar) {
          child.children = child.children.filter(item => item.id !== ch1.id)
        }
      }
    },
    // turn off/on layers
    changeLayers (selectableArray, layerId) {
      this.$store.dispatch('setMapUpdating', true)
      const selectedService = this.allServices.find(obj => obj.id === layerId)
      const difference = selectableArray
        .filter((x) => !this.oldSelection[layerId].includes(x))
        .concat(this.oldSelection[layerId].filter((x) => !selectableArray.includes(x)))
      this.oldSelection[layerId] = selectableArray
      if (difference[0].children.length === 0) {
        if (selectedService.allSublayers !== undefined) {
          for (const dif of difference) {
            let parentChecked = false
            if (this.isParentChecked(dif, this.items[layerId])) {
              parentChecked = true
            }
            const rootNode = this.items[layerId].find(obj => obj.root === true)
            if (parentChecked || rootNode.checked === false) {
              const layerToChange = selectedService.allSublayers.items.find(obj => obj.id === dif.id)
              layerToChange.visible = !layerToChange.visible
            }
          }
        } else {
          selectedService.visible = !selectedService.visible
        }
      } else if (difference[0].root === true) {
        selectedService.visible = !selectedService.visible
        const root = this.items[layerId].find(obj => obj.root === true)
        root.checked = !root.checked
      } else {
        this.changeCheckedStatusOfParentNode(difference[0], this.items[layerId])
        for (const child of selectableArray) {
          if (
            child.children.length === 0 &&
              this.isChildOfDifNode(child, difference[0].children)
          ) {
            const layerToChange = selectedService.allSublayers.items.find(obj => obj.id === child.id)
            const rootNode = this.items[layerId].find(obj => obj.root === true)
            layerToChange.visible = this.isParentChecked(child, this.items[layerId]) || rootNode.checked === false
              ? !layerToChange.visible : false
          }
        }
      }
      this.$store.dispatch('setMapUpdating', false)
    },
    isChildOfDifNode (child, difNode) {
      for (const ch of difNode) {
        if (ch.id === child.id) {
          return true
        }
        if (ch.children.length > 0) {
          const response = this.isChildOfDifNode(child, ch.children)
          if (response) {
            return response
          }
        }
      }
      return false
    },
    isParentChecked (difChild, items) {
      for (const item of items) {
        if (item.children.length === 0 && difChild.id === item.id) {
          return true
        }
        if (((item.checked === true && item.children.length > 0) || (item.children.length > 0 && item.root === true))) {
          const response = this.isParentChecked(difChild, item.children)
          if (response) {
            return response
          }
        }
      }
      return false
    },
    changeCheckedStatusOfParentNode (dif, items) {
      for (const item of items) {
        if (item.id === dif.id) {
          item.checked = !item.checked
          return item.checked
        }
        this.changeCheckedStatusOfParentNode(dif, item.children)
      }
      return false
    },
    pushInParent (child, parentId, idOfLayer, subLayerIds, allSublayers, items) {
      const containInPrivilege = allSublayers.some((e) => e.id === child.id)

      const result = allSublayers.find(obj => obj.id === child.id)
      for (const item of items) {
        if (item.id === parentId) {
          if (subLayerIds === null && containInPrivilege) {
            if (result?.visible === true) {
              this.selection[idOfLayer].push(child)
            }
            item.children.push(child)
            return
          }
          if (subLayerIds) {
            if (result?.visible === true) {
              this.selection[idOfLayer].push(child)
            }
            item.children.push(child)
            return
          }
        } else {
          this.pushInParent(
            child,
            parentId,
            idOfLayer,
            subLayerIds,
            allSublayers,
            item.children
          )
        }
      }
    },
    changeSelection (services) {
      for (const [item] of Object.entries(this.items)) {
        const service = services.filter(e => e.mapUrl === this.items[item][0].url)
        if (service[0]) {
          const rootItem = this.items[item].find(e => e.url === service[0].mapUrl)
          if (service[0].type === 'dynamic') {
            if (rootItem.checked === false) {
              this.selection[item].push(rootItem)
              this.selection[item] = [...this.selection[item]]
            }
          } else {
            const serviceItem = this.selection[item].find(e => e.url === service[0].mapUrl)
            if (serviceItem) {
              continue
            } else {
              this.selection[item].push(rootItem)
              this.selection[item] = [...this.selection[item]]
            }
          }
          if (service[0].layers) {
            for (const layer of this.selection[item]) {
              if (layer.root || layer.children.length !== 0) {
                continue
              } else if (service[0].layers?.includes(layer.id)) {
                continue
              } else {
                this.selection[item] = this.selection[item].filter((item) => item.id !== layer.id)
              }
            }
          }
          if (service[0].layers?.length) {
            for (const lay of service[0].layers) {
              const sel = this.selection[item].filter(e => e.id === lay)
              if (sel.length) {
                continue
              } else {
              // pronadji u this.items[item] i dodaj
                const addItem = this.searchTree(this.items[item][0], lay)
                this.selection[item].push(addItem)
                this.selection[item] = [...this.selection[item]]
              }
            }
          }
        } else if (this.selection[item].length) {
          if (this.selection[item].length === 1) {
            this.selection[item] = []
          } else {
            // staviti checked u items na false
            this.selection[item] = this.selection[item].filter(e => e.root !== true)
          }
        }
        this.$forceUpdate()
      }
    },
    searchTree (element, id) {
      if (element.id === id) {
        return element
      } else if (element.children?.length > 0) {
        let result = null
        for (let i = 0; result == null && i < element.children.length; i++) {
          result = this.searchTree(element.children[i], id)
        }
        return result
      }
      return null
    },
    changeTransparency (event, item) {
      if (spEsri.mapImageLayers[item.key]) {
        const mapImageLayers = spEsri.mapImageLayers
        mapImageLayers[item.key].opacity = 1 - event
      }
      if (spEsri.wmsLayers[item.key]) {
        spEsri.wmsLayers[item.key].opacity = 1 - event
      }
      if (spEsri.buildingLayers[item.key]) {
        spEsri.buildingLayers[item.key].buildingLayer.opacity = 1 - event
      }
      if (spEsri.wmtsLayers[item.storeKey]) {
        spEsri.wmtsLayers[item.storeKey].opacity = 1 - event
      }
      const sceneLayers = spEsri.sceneLayers
      for (const key in sceneLayers) {
        const sl = sceneLayers[key].sceneLayer
        const url = item.url.replace('/' + sl.layerId, '')
        if (sl.url === url) {
          sl.opacity = 1 - event
        }
      }

      if (item.type === 'feature') {
        const featureLayers = spEsri.featureLayers
        for (const key in featureLayers) {
          const url = item.url.replace('/' + featureLayers[key].layerId, '')
          if (featureLayers[key].url === url) {
            featureLayers[key].opacity = 1 - event
          }
        }
      }

      const imageryLayers = spEsri.imageryLayers
      for (const key in imageryLayers) {
        if (imageryLayers[key].url === item.url) {
          imageryLayers[key].opacity = 1 - event
        }
      }

      item.transparency = event
    },
    changeBasemapOpacity (basemapOpacity) {
      if (spEsri.map.basemap.baseLayers.items) {
        for (const baseLayer of spEsri.map.basemap.baseLayers.items) {
          baseLayer.opacity = basemapOpacity
        }
      }
      if (spEsri.map.basemap.referenceLayers.items) {
        for (const referenceLayer of spEsri.map.basemap.referenceLayers.items) {
          referenceLayer.opacity = basemapOpacity
        }
      }
      // spEsri.map.ground = null
      spEsri.map.ground.opacity = basemapOpacity
    },
    changeTransparencyBasemap (event) {
      this.basemapTransparency = event
      if (this.selected) {
        this.changeBasemapOpacity(1 - event)
      }
    },
    resize () {
      if (this.activeTool === 'toc') {
        const containerH = this.$refs.container.clientHeight
        const headerH = this.$refs.widgetHeader.$refs.header.clientHeight
        const tabsH = this.$refs.agTocTabs.clientHeight
        this.headerHeight = headerH + 'px'
        this.fullHeaderHeight = (headerH + tabsH) + 'px'
        // - 1 in next line => show full scrollbar
        // otherwise bottom of scrollbar would be cut
        this.computedHeight = containerH - headerH - tabsH - 1 + 'px'
      }
    },
    getLegendAfterTabIsChanged () {
      if (!this.legendCreated) {
        setTimeout(() => {
          this.getLegend()
        }, 300)
      }
    },
    getLegend () {
      if (!this.legendCreated) {
        this.$options.legendWidget = new Legend({
          view: spEsri.activeView,
          container: 'legendDiv',
        })
        this.legendCreated = true
      }
    },
    isAnyLayerLabelActive (labeling) {
      for (const key in labeling) {
        if (labeling[key].isLabelActive) {
          return true
        }
      }
      return false
    },
    isAnyLayerSymbologyActive (symbology) {
      for (const key in symbology) {
        if (symbology[key].isActive) {
          return true
        }
      }
      return false
    },
    openLayerFiltering (layer) {
      this.$emit('open-layer-filter', layer)
    },
    openAttributeTable (layer) {
      this.$store.dispatch('setOperationUsedToCreateResults', 'tocAttributes')
      this.$store.dispatch('setCurrentWidgetInResults', 'Toc')
      this.$emit('open-attribute-table', layer)
    },
    openLayerLabeling (layer) {
      this.$emit('open-layer-labeling', layer)
    },
    openLayerSymbology (layer) {
      this.$emit('open-layer-symbology', layer)
    },
  },
}
</script>

<style>
.disabledItem {
  color:rgba(83, 83, 83, 0.471)
}
h3.esri-widget__heading.esri-legend__service-label {
  font-family: Rubik, sans-serif;
}
.esri-legend__layer-caption {
  font-family: Rubik, sans-serif;
}
.esri-legend__layer-cell.esri-legend__layer-cell--info {
  font-family: Rubik, sans-serif;
}
.v-application--is-ltr .v-treeview-node__checkbox {
  font-size: 20px;
}
.esri-legend__layer-table {
  margin-bottom: 0px !important;
}
.esri-widget__heading {
  font-weight: 500 !important;
  margin: 0px !important;
}

</style>
